/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { getPages, getPagesCount } from "../../../_helpers";

export function PaginationLinks({ paginationProps }) {
  const { totalSize, sizePerPage, page, paginationSize } = paginationProps;
  const pagesCount = getPagesCount(totalSize, sizePerPage);
  const pages = getPages(page, pagesCount, paginationSize);
  const handleFirstPage = ({ onPageChange }) => {
    onPageChange(1);
  };

  const handlePrevPage = ({ page, onPageChange }) => {
    onPageChange(page - 1);
  };

  const handleNextPage = ({ page, onPageChange }) => {
    if (page < pagesCount) {
      onPageChange(page + 1);
    }
  };

  const handleLastPage = ({ onPageChange }) => {
    onPageChange(pagesCount);
  };

  const handleSelectedPage = ({ onPageChange }, pageNum) => {
    onPageChange(pageNum);
  };

  const disabledClass = pagesCount > 1 ? "" : "disabled";
  return (
    <>
      {pagesCount < 2 && <></>}
      {pagesCount > 1 && (
          <nav>
            <ul className="pagination pagination-rounded mb-0">
              <li className="page-item">
                  <a
                    onClick={() => handleFirstPage(paginationProps)}
                    className="page-link"
                  >
                    <i className="mdi mdi-skip-backward" />
                  </a>
              </li>
              <li className="page-item">
                  <a
                    onClick={() => handlePrevPage(paginationProps)}
                    className="page-link"
                  >
                    <i className="mdi mdi-skip-previous" />
                  </a>
              </li>
                  {page > 1 && (
                      <li className="page-item">
                    <a     className="page-link">
                      ...
                    </a>
                      </li>
                  )}
                  {pages.map((p) => (
                      <li className="page-item">
                    <a
                      key={p}
                      onClick={() => handleSelectedPage(paginationProps, p)}
                      className={`page-link ${
                        page === p ? "active" : ""
                      }`}
                    >
                      {p}
                    </a>
                      </li>
                  ))}
                  {page < pagesCount && (
                      <li className="page-item">
                    <a     className="page-link">
                      ...
                    </a>
                      </li>
                  )}
              <li className="page-item">
                  <a
                    onClick={() => handleNextPage(paginationProps)}
                    className="page-link"
                  >
                    <i className="mdi mdi-skip-next"></i>
                  </a>
              </li>
              <li className="page-item">
                  <a
                    onClick={() => handleLastPage(paginationProps)}
                    className="page-link"
                  >
                    <i className="mdi mdi-skip-forward"></i>
                  </a>
              </li>
            </ul>
          </nav>
      )}
    </>
  );
}
